export default __webpack_public_path__ + "static/media/task-execution.c36b04c3.PNG";